import { gql } from '@apollo/client';
import OrganizationDetailsFragment from "../../../fragments/CompanyAdminContext/OrganizationDetails";

const GET_ORGANIZATION_DETAILS = gql`
  query getOrganizationDetails($companyId: Int!) {
    companyAdminContext {
      organizationDetails {
        getOrganizationDetails(companyId: $companyId) {
          ...OrganizationDetails
        }
      }
    }
  }
  ${OrganizationDetailsFragment}
`;

export default GET_ORGANIZATION_DETAILS;
